const prvaDiagnozaGDPRSoglasje = {
    qPrivolitve1: { 
        name: 'qPrivolitve1',
        type: 'tns:DaNe',
        formType: 'radio',
        value: undefined,
        required: true,
        error: null,
        text: {
            sl: 'Za namen izvajanja neposrednega trženja, ki vključuje oblikovanje meni prilagojenih ponudb ter novic na podlagi ocenjevanja in predvidevanja mojih interesov, ekonomskega položaja, potreb, zahtev, navad, osebnega okusa in drugih lastnosti.',
        },
    },
    qPrivolitve2: { 
        name: 'qPrivolitve2',
        type: 'tns:DaNe',
        formType: 'radio',
        value: undefined,
        required: true,
        error: null,
        text: {
            sl: 'Za isti zgoraj izbrani namen, moje osebne podatke posreduje družbam, ki se ukvarjajo z dejavnostjo zavarovalnega zastopanja ali posredovanja, in s Prvo osebno zavarovalnico, d.d., kapitalsko povezanim družbam, ki se ukvarjajo z dejavnostmi in izvajajo storitve, vsebovane v splošnih ali dopolnilnih zavarovalnih pogojih (oskrba na domu, zdravstvena asistenca, storitve pogreba …) ali financnimi storitvami. Za kapitalsko povezane družbe se štejejo družbe, ki so v neposredni ali posredni vecinski lasti Prve osebne zavarovalnice, d.d., ali Prvi osebni zavarovalnici, d.d., nadrejenih (posredno ali neposredno) oseb.',
        },
    },
    podpis: { 
        name: 'podpis',
        type: 'xs:base64Binary',
        formType: 'signature',
        required: true,
        value: undefined,
        text: {
            sl: 'Podpis zavarovalca',
        },
    },
    nacinObvescanja: {
        name: 'nacinObvescanjaPrvaDiagnoza',
        type: 'quasi',
        formType: 'nacin-obvescanja-prvadiagnoza',
        required: true,
        error: null,
        value: {
            nacinObvescanjaPoNavadniPosti: false,
            nacinObvescanjaElektronskaPosta: false,
            nacinObvescanjaPoTelefonu: false,
        },
        options: [
            {
                name: 'nacinObvescanjaPoNavadniPosti',
                value: 'nacinObvescanjaPoNavadniPosti',
                text: {
                    sl: 'po navadni posti',
                },
            },
            {
                name: 'nacinObvescanjaElektronskaPosta',
                value: 'nacinObvescanjaElektronskaPosta',
                text: {
                    sl: 'po elektronski posti',
                },
            },
            {
                name: 'nacinObvescanjaPoTelefonu',
                value: 'nacinObvescanjaPoTelefonu',
                text: {
                    sl: 'po telefonu',
                },
            },
        ]
    },
}

module.exports = { prvaDiagnozaGDPRSoglasje };